var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowMore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3802 11.2793L16 18.6975L8.61976 11.2793C8.24922 10.9069 7.64844 10.9069 7.2779 11.2793C6.90736 11.6518 6.90737 12.2557 7.27791 12.6281L15.3291 20.7207C15.6996 21.0931 16.3004 21.0931 16.6709 20.7207L24.7221 12.6281C25.0926 12.2557 25.0926 11.6518 24.7221 11.2793C24.3516 10.9069 23.7508 10.9069 23.3802 11.2793Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowMore);
export default __webpack_public_path__ + "static/media/show_more.785d0510.svg";
export { ForwardRef as ReactComponent };var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowMore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3802 11.2793L16 18.6975L8.61976 11.2793C8.24922 10.9069 7.64844 10.9069 7.2779 11.2793C6.90736 11.6518 6.90737 12.2557 7.27791 12.6281L15.3291 20.7207C15.6996 21.0931 16.3004 21.0931 16.6709 20.7207L24.7221 12.6281C25.0926 12.2557 25.0926 11.6518 24.7221 11.2793C24.3516 10.9069 23.7508 10.9069 23.3802 11.2793Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowMore);
export default __webpack_public_path__ + "static/media/show_more.785d0510.svg";
export { ForwardRef as ReactComponent };